export enum TransactionType {
  'TASK' = 'TASK',
  'WORKFLOW_QUEUE' = 'WORKFLOW_QUEUE',
  'NOTE' = 'NOTE',
}
